import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { WOE_BASIC_Schema } from './M_WOE_BASIC_Schema';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';

const toDataResponse = (res) =>
  res != null && Array.isArray(res) ? { data: res } : res;

export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      WOE_BASIC_Schema.mapper.search1,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.WorkEnd.getWoeBasicR2,
      params
    );
    const dataResponse = toDataResponse(res);
    return dataResponse;
  }, successOptions);
};
